<button mat-icon-button [matMenuTriggerFor]="moreMenu" aria-label="More" (click)="$event.stopPropagation()">
    <mat-icon class="secondary-text">star</mat-icon>
</button>

<mat-menu #moreMenu="matMenu">
    <mat-action-list>
        @for (view of projectViews$ | async; track view.id) {
            <mat-list-item (click)="clickView(view.id, $event)">
                <div xLayout="row" fxLayoutAlign="space-between center" fxFlex="1 0 auto">
                    <p class="text-truncate">{{ view?.name || "" }}</p>
                    @if (deviceInView(view)) {
                        <mat-icon>check</mat-icon>
                    }
                </div>
            </mat-list-item>
        }
    </mat-action-list>
</mat-menu>
